import React, { Component } from 'react';

import { BrowserRouter } from "react-router-dom";

//Font Awesome Icons
import '../adminlte3/plugins/font-awesome/css/font-awesome.min.css';
//Theme style 
import '../adminlte3/dist/css/adminlte.min.css';
// Google Font: Source Sans Pro
//import 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700';

//bootstrap rtl
import '../adminlte3/dist/css/bootstrap-rtl.min.css';

//template rtl version
import '../adminlte3/dist/css/custom-style.css';


export class PageTemplate extends Component {


  constructor(props) {
    super(props);
    this.addJavaScriptFile = this.addJavaScriptFile.bind(this);


    this.pages = [];

    this.pages.push({ id: 1, link: "/ghorekeshi", label: " مدیریت قرعه کشی ", selected: false });
    this.pages.push({ id: 2, link: "/prizePage", label: "جوایز", selected: false });
    this.pages.push({ id: 3, link: "/recieveSMSTable", label: "ریزگزارش شرکت کنندگان ", selected: false });
    this.pages.push({ id: 4, link: "/sendSMSTable", label: "پیامکهای ارسالی", selected: false });    
    this.pages.push({ id: 5, link: "/winner", label: " گزارش برندگان ", selected: false });
    this.pages.push({ id: 6, link: "/block", label: "حذفیات ", selected: false });
   // this.pages.push({ id: 7, link: "/pointTable", label: "امتیاز ها", selected: false });
    //this.pages.push({ id: 5, link: "/aggregateMobileTable", label: " گزارش تجمیعی شرکت کنندگان", selected: false });
    this.pages.push({ id: 8, link: "/productTable", label: "گزارش محصولات", selected: false });
    this.pages.push({ id: 9, link: "/memberTable", label: "پروفایل شرکت کنندگان", selected: false });    
    this.pages.push({ id: 10, link: "/taskTable", label: "گزارشات", selected: false });

  }


  componentDidMount() {
    //  this.addJavaScriptFile(require('../adminlte3/plugins/jquery/jquery.min.js'));
    //  this.addJavaScriptFile(require('../adminlte3/plugins/bootstrap/js/bootstrap.bundle.min.js'));
    // this.addJavaScriptFile(require('../adminlte3/dist/js/adminlte.min.js'));
  }

  addJavaScriptFile(e) {

    const script = document.createElement("script");

    script.src = e;
    script.async = true;

    document.body.appendChild(script);
  }





  render() {


    var Rows = this.pages.map(
      (data) =>
        <li className="nav-item">
          <a href={data.link} className={data.link == this.props.link ? "nav-link active" : "nav-link"}>
            <i className="fa fa-circle-o nav-icon"></i>
            <p>{data.label}</p>
          </a>
        </li>
    );

    if (this.props.hidemaster === true) {
      return(<div className="container" style={{ width: "100%" }}>
          {this.props.children}
        </div>);
    }


    return (<div className="hold-transition sidebar-mini" style={{ width: "100%" }}>
      <div className="wrapper">

        <nav className="main-header navbar navbar-expand bg-white navbar-light border-bottom">

          <ul className="navbar-nav">
            <li className="nav-item d-block d-sm-block d-md-block d-lg-none">
              <a className="nav-link" data-widget="pushmenu" href="#"><i className="fa fa-bars"></i></a>
            </li>
            <li className="nav-item d-none d-sm-inline-block">
              <a href="logout" className="nav-link">خروج</a>
            </li>

          </ul>




        </nav>



        <aside className="main-sidebar sidebar-dark-primary elevation-4">

          <div className="brand-link">
            <img src={require('../adminlte3/dist/img/AdminLTELogo.png')} alt="AdminLTE Logo" className="brand-image img-circle elevation-3"
              style={{ "opacity": "0.8" }} />
            <span className="brand-text font-weight-light">پنل مدیریت</span>
          </div>


          <div className="sidebar">
            <div>
              <div className="brand-link">

                <span className="brand-text font-weight-light">{this.props.username}</span>
              </div>


              <nav className="mt-2">
                <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">


                  <li className="nav-item has-treeview menu-open">
                    <ul className="nav nav-treeview">
                      {Rows}
                    </ul>
                  </li>
                </ul>
              </nav>

            </div>
          </div>

        </aside>


        <div className="content-wrapper" style={{ height: '700px' }}>

          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">{this.props.pageLabel}</h1>
                </div>

              </div>
            </div>
          </div>



          <div className="content">
            <div className="container-fluid">
              <div className="row" >
                <div className="card" style={{ width: "100%" }}>
                  {this.props.children}
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageTemplate.js